module.exports = __webpack_public_path__ + "static/media/14585789_1361634910521189_1057312586_o.f77e6111.jpg";